import { createContext, useContext } from 'react';
import { initialState } from './Integrations.constants';
import { tIntegrationsContext } from './Integrations.types';

export const IntegrationsContext = createContext(initialState);

export const useIntegrationsContext = (): tIntegrationsContext =>
  useContext(IntegrationsContext);
